/* eslint-disable @typescript-eslint/naming-convention */
export const ROUTE_PATHS = {
  ADVERTISERS_LIST: "/advertisers",
  ADVERTISER_DETAIL: "/advertisers/:id",
  ADVERTISER_BILLING_LOGS: "/advertisers/:id/billing-logs",
  CAMPAIGNS_CREATE: "/campaigns/create",
  MANAGED_CAMPAIGN_CREATE: "/campaigns/create/managed",
  CUSTOM_CAMPAIGN_CREATE: "/campaigns/create/custom",
  RE_TARGETING_SEGMENTS: "/retargeting-segments",
  DASHBOARD: "/dashboard",
  PUBLIC_CAMPAIGNS_PICKER: "/public-campaigns-picker",
  TERMS_PAGE: "/terms-of-use",
  PRIVACY_PAGE: "/privacy-policy",
  ROOT: "/",
  SIGNUP: "/bgsignup",
  FORGOT_PASSWORD: "/request-password-reset",
  ALLBILLINGLOGS: "/allbillinglogs",
  PUBLICATION_LISTS: "/publication-lists",
  ZIP_CODES: "/zip-codes",
  ADS_UPLOAD: "/ads-upload",
  TARGET_COMPANIES: "/target-companies",
  ROLES_AND_TITLES: "/roles-titles",
  SEGMENTS_LOGS: "/segments-logs",
};
